import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import { updateTcOrder } from 'actions/tc/orders';

import api from 'services';
import AutoComplete from 'material-ui/AutoComplete';
import { useRefState } from 'helpers/react.utils';
import { Checkbox, Chip, IconButton } from 'material-ui';
import ContentAddIcon from 'material-ui/svg-icons/content/add-circle-outline';

const styles = {
    add: {
        display: 'flex',
        justifyContent: 'center',
    },
    chips: {
        margin: '8px 8px 0 0',
    },
};

function RegisterClassMulti({ numberOrderTable, tcOrder, updateTcOrder }) {
    const [classes, setClasses] = useState([]);
    const [selectedClass, setselectedClass] = useState(getDefaultRegisterClass());
    const [search, setSearch, searchRef] = useRefState('');

    const changeAutoComplete = async (searchText) => {
        setSearch(searchText);

        if (searchText.length < 2) {
            return;
        }

        const classes = await api.findClasses(searchText);

        if (searchRef.current !== searchText) {
            return;
        }

        if (classes.status === 200) {
            setClasses(classes.data.data);
        }
    };

    const chooseAutoComplete = (selected) => {
        setselectedClass({ ...getDefaultRegisterClass(), ...selected });
    };

    const addRegisterClass = () => {
        const _tcOrder = _.cloneDeep(tcOrder);
        const { _id, iacsRegister, name } = selectedClass;

        if (Array.isArray(_tcOrder.vesselRequirements.registerClasses)) {
            const alreadyExists = _tcOrder.vesselRequirements.registerClasses.findIndex(i => i._id === _id && i.iacsRegister === iacsRegister && i.name === name);

            if (alreadyExists < 0) {
                _tcOrder.vesselRequirements.registerClasses.push(selectedClass);
                updateTcOrder(numberOrderTable, _tcOrder);
            }
        } else {
            _tcOrder.vesselRequirements.registerClasses = [selectedClass];
            updateTcOrder(numberOrderTable, _tcOrder);
        }

        setselectedClass(getDefaultRegisterClass());
        setSearch('');
    };

    const deleteRegisterClass = (index) => {
        const _tcOrder = _.cloneDeep(tcOrder);

        _tcOrder.vesselRequirements.registerClasses.splice(index, 1);

        updateTcOrder(numberOrderTable, _tcOrder);
    };

    const changeSelected = (field, value) => {
        setselectedClass({
            ...selectedClass,
            [field]: value,
        });
    };

    return (
        <React.Fragment>
            <div className='row' style={{ height: '72px' }}>
                <div className='col-xs-6'>
                    <AutoComplete
                        name='cargoName'
                        textFieldStyle={{ fontSize: '16px' }}
                        hintText="Register classes"
                        searchText={search || selectedClass.name || ''}
                        dataSource={classes}
                        dataSourceConfig={{ text: 'name', value: 'item' }}
                        onUpdateInput={value => changeAutoComplete(value)}
                        onNewRequest={value => chooseAutoComplete(value)}
                        filter={AutoComplete.noFilter}
                        listStyle={{ overflow: 'auto', maxHeight: '300px', width: 'auto' }}
                        menuStyle={{ width: 'auto' }}
                        popoverProps={{
                            canAutoPosition: true,
                        }}
                        fullWidth
                    />

                </div>
                <div className='col-xs-3'>
                    <Checkbox
                        label="IACS register"
                        iconStyle={{ marginRight: '5px' }}
                        checked={selectedClass && selectedClass.iacsRegister}
                        onCheck={() => changeSelected('iacsRegister', !selectedClass.iacsRegister)}
                        disabled={!!selectedClass._id}
                    />
                </div>
                <div className='col-xs-2'>
                    <Checkbox
                        label="Excluded"
                        iconStyle={{ marginRight: '5px' }}
                        checked={selectedClass.excluded}
                        onCheck={() => changeSelected('excluded', !selectedClass.excluded)}
                    />
                </div>
                <div className='col-xs-1'>
                    <IconButton>
                        <ContentAddIcon
                            onClick={addRegisterClass}
                            color='green'
                        />
                    </IconButton>
                </div>
            </div>
            <div className='row'>
                <div className='col-xs-12' style={{ display: 'flex', flexFlow: 'wrap' }}>
                    {
                        tcOrder.vesselRequirements.registerClasses && tcOrder.vesselRequirements.registerClasses.map((registerClass, index) => {
                            const backgroundColor = registerClass.excluded ? '#e6e6e6' : '#d6edbd';
                            return (
                                <Chip
                                    key={`cgo_${index}`}
                                    onRequestDelete={() => deleteRegisterClass(index)}
                                    style={{ ...styles.chips, backgroundColor, whiteSpace: 'initial' }}
                                >
                                    {
                                        registerClass.iacsRegister && 
                                        <span>(IACS)</span>
                                    }
                                    {registerClass.excluded && ' - '}{`${registerClass.name || 'Any'}`}
                                </Chip>
                            );
                        })
                    }
                </div>
            </div>
        </React.Fragment>
    );
}

export const RegisterClassMultiNoRedux = RegisterClassMulti;

export default connect(
    null,
    dispatch => bindActionCreators({
        updateTcOrder,
    }, dispatch),
)(RegisterClassMulti);

const getDefaultRegisterClass = () => ({
    _id: null,
    excluded: false,
    iacsRegister: false,
    name: null,
    registerClass: null,
});



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/RegisterClassMulti.jsx